<template>
  <div class="app-container">
    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="bgk-img" :class="{ 'is-fallback': bannerLoadFailed }">
        <img
          v-if="!bannerLoadFailed"
          src="https://www.hketang.cn/_nuxt/img/course-banner.2811f9b.png"
          alt="课程中心"
          @error="handleBannerError"
        />
        <div v-else class="banner-fallback">
          <!-- <img src="@/assets/logo.png" alt="H课堂" class="banner-logo" /> -->
          <div class="banner-content">
            <div class="banner-title">课程中心</div>
            <div class="banner-subtitle">编程学院、公开课、进阶课等优质内容</div>
          </div>
        </div>
      </div>
      <div class="tabs-box">
        <div class="tabs">
          <div class="tab left" @click="tabschange(1)"  :class="tabsactive == 1 ? 'active':''">编程学院</div>
          <div class="tab" @click="tabschange(2)"  :class="tabsactive == 2 ? 'active':''">公开课</div>
          <div class="tab" @click="tabschange(3)" :class="tabsactive == 3 ? 'active':''">进阶课</div>
          <div class="tab" @click="tabschange(4)" :class="tabsactive == 4 ? 'active':''">专项课</div>
          <div class="tab right" @click="tabschange(5)" :class="tabsactive == 5 ? 'active':''">综合课</div>
        </div>
        <div class="listbox">
          <div class="classlist" v-for="(item, i) in collegeList" :key="i" @click="handledetal(item)">
              <div class="infobox">
                <img :src="item.coverUrl" alt="" />
                <div class="info">
                  <span class="title">{{ item.name }}</span>
                  <span class="type">{{ item.typeName || '课程' }}</span>
                </div>
              </div>
              <div class="perinfo">
                <img :src="item.teacherAvatars && item.teacherAvatars[0] ? item.teacherAvatars[0] : 'https://web-1322480718.cos.ap-nanjing.myqcloud.com/20240807/20240807122351_esxl.jpg'" alt="" />
                <div class="pername">{{ item.teacherNames && item.teacherNames[0] ? item.teacherNames[0] : '讲师' }}</div>
              </div>
              <div class="money">{{ item.fee ? '￥' + item.fee : '免费' }}</div>
              <div class="signup">
                <span class="nums">{{ item.applicantsNumber }}</span>
                人报名
              </div>
            </div>
            <el-pagination
              background
              layout="prev, pager, next"
              style="text-align: right"
              :total="total"
              :page-size="pagesize"
              :current-page="currentPage"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>
import { courseinfo } from "@/api/index.js";
export default {
  name: "home",
  components: {},
  data() {
    return {
      tabsactive: 1,
      bannerLoadFailed: false,
      total: 0,
      pagesize: 10,
      currentPage: 1,
      collegeList: [],
    };
  },
  computed: {
   
  },
  created() {
    this.tabsactive = this.normalizeTabType(this.$store.state.classtype);
    this.getcourseinfo();
  },
  
  methods: {
    normalizeTabType(val) {
      const tabType = Number(val);
      return [1, 2, 3, 4, 5].includes(tabType) ? tabType : 1;
    },
    tabschange(val) {
      const nextType = this.normalizeTabType(val);
      this.tabsactive = nextType;
      this.$store.commit('classtype', nextType);
      this.currentPage = 1; // 切换类型时重置页码
      this.getcourseinfo();
    },
    handleBannerError() {
      this.bannerLoadFailed = true;
    },
    getcourseinfo() {
      // 根据tabsactive映射到后端的type值
      let typeMap = {
        1: "1", // 编程学院
        2: "2", // 公开课
        3: "3", // 进阶课
        4: "4", // 专项课
        5: "5", // 综合课
      };
      const currentType = this.normalizeTabType(this.tabsactive);
      this.tabsactive = currentType;
      
      courseinfo({
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        typeId: typeMap[currentType],
      }).then((res) => {
        if (res.data && res.data.list) {
          this.collegeList = res.data.list;
          this.total = res.data.total || 0;
        } else {
          this.collegeList = [];
          this.total = 0;
        }
      }).catch(error => {
        console.error('获取课程信息失败:', error);
        this.collegeList = [];
        this.total = 0;
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getcourseinfo();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.currentPage = 1; // 改变页面大小时重置页码
      this.getcourseinfo();
    },
    handledetal(val) {
      this.$store.commit("activeNavIndex", 1);
      this.$router.push({ path: "/coursedetals", query: { id: val.id } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.app-container {
  background-color: rgb(255, 255, 255);

  padding: 0;
  margin: 0;
  font-family: "Microsoft YaHei";
  color: #333;
  overflow: hidden;
  clear: both;
  .main-content {
    .bgk-img {
      width: 100%;
      height: 210px;
      z-index: 2;
      background: linear-gradient(135deg, #eef4ff 0%, #f9fbff 55%, #e6eefc 100%);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.is-fallback {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .banner-fallback {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
      }
      .banner-logo {
        width: 96px;
        height: 84px;
        object-fit: contain;
      }
      .banner-content {
        text-align: left;
      }
      .banner-title {
        font-size: 34px;
        line-height: 1.2;
        color: #2d3341;
        font-weight: 700;
      }
      .banner-subtitle {
        margin-top: 10px;
        font-size: 16px;
        color: #6b7280;
      }
    }
    .tabs-box{
      width: 100%;
      font-size: 18px;
      background-color: #f5f6f9;
      padding: 0 0 60px 0;
      position: relative;
      .tabs {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        margin-top: -20px;
        background-color: #f5f6f9;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        position: relative;
        z-index: 10;
        .tab{
          flex: 1;
          height: 74px;
          background: transparent;
          font-weight: 500;
          color: #2d3341;
          line-height: 74px;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          z-index: 1;
          &:hover {
            color: #d5182f;
          }
        }
        .left {
          border-top-left-radius: 20px;
        }
        .right {
          border-top-right-radius: 20px;
        }
        .active{
            background: #fff;
            height: 74px;
            line-height: 74px;
            margin-top: 0;
            border-top-right-radius: 20px;
            border-top-left-radius: 20px;
            color: #d5182f;
            font-weight: 700;
            z-index: 2;
            &::after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              width: 40px;
              height: 3px;
              background-color: #d5182f;
              border-radius: 2px;
            }
        }
      }
      .listbox{
        width: 1200px;
        margin: 0 auto;
        background: #fff;
        padding: 30px;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
        
        .classlist {
          width: 1140px;
          height: auto;
          min-height: 98px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;
          padding: 16px 20px;
          cursor: pointer;
          border-radius: 8px;
          background: #fff;
          border: 1px solid transparent;
          transition: all 0.3s ease;
          &:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 20px rgba(0,0,0,0.06);
            border-color: #f0f0f0;
          }
          .infobox {
            width: 362px;
            font-size: 16px;
            text-align: left;
            display: flex;
            align-items: center;
            margin-right: 20px;
            img {
              width: 154px;
              height: 98px;
              margin-right: 25px;
              border-radius: 6px;
              object-fit: cover;
            }
            .info {
              height: 60px;
              .title {
                display: block;
                color: #2d3341;
                margin-bottom: 20px;
              }
              .type {
                display: block;
                color: #838a9d;
              }
            }
          }
          .perinfo {
            display: flex;
            align-items: center;
            width: 242px;
            img {
              width: 42px;
              height: 42px;
              border-radius: 50%;
              margin-right: 10px;
            }
            .pername {
              color: #838a9d;
              font-size: 16px;
              margin-bottom: 10px;
            }
          }
          .money {
            width: 226px;
            color: #d5182f;
            font-size: 18px;
            font-weight: 600;
          }
          .signup {
            width: 226px;
            .nums {
              color: #d5182f;
              font-weight: 500;
            }
          }
        }
      }
      .block {
        margin-top: 40px;
        padding-bottom: 20px;
        :deep(.el-pagination.is-background .el-pager li:not(.disabled).active ){
          background-color: #d5182f;
          color: #FFF;
        }
        :deep(.el-pagination.is-background .el-pager li:hover ){
          color: #d5182f;
        }
      }
    }
   
  }
}

/* ====== Mobile responsive overrides for Course List page ====== */
@media (max-width: 1200px) {
  .app-container .main-content .bgk-img .banner-fallback {
    width: auto;
    padding: 0 16px;
  }
  .app-container .main-content .tabs-box .tabs {
    width: 100%;
    max-width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
  }
  .app-container .main-content .tabs-box .listbox {
    width: 100%;
    max-width: 100%;
    padding: 20px 12px;
    box-sizing: border-box;
  }
  .app-container .main-content .tabs-box .listbox .classlist {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .app-container .main-content .bgk-img {
    height: auto;
    min-height: 140px;
  }
  .app-container .main-content .bgk-img .banner-fallback {
    flex-direction: column;
    text-align: center;
    padding: 24px 16px;
    gap: 12px;
  }
  .app-container .main-content .bgk-img .banner-content {
    text-align: center;
  }
  .app-container .main-content .bgk-img .banner-title {
    font-size: 26px;
  }
  .app-container .main-content .tabs-box {
    padding-bottom: 32px;
  }
  .app-container .main-content .tabs-box .tabs {
    flex-wrap: nowrap;
    margin-top: 0;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    border-radius: 16px 16px 0 0;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .app-container .main-content .tabs-box .tabs .tab {
    flex: 0 0 auto;
    min-width: 96px;
    height: 52px;
    line-height: 52px;
    padding: 0 14px;
    font-size: 15px;
    white-space: nowrap;
    border-radius: 0;
  }
  .app-container .main-content .tabs-box .tabs .active {
    height: 52px;
    line-height: 52px;
  }
  .app-container .main-content .tabs-box .listbox {
    border-radius: 0 0 16px 16px;
  }
  .app-container .main-content .tabs-box .listbox .classlist {
    width: 100%;
    height: auto;
    min-height: auto;
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 12px;
    margin-bottom: 12px;
  }
  .app-container .main-content .tabs-box .listbox .classlist .infobox {
    width: 100%;
    margin: 0 0 10px 0;
    align-items: flex-start;
  }
  .app-container .main-content .tabs-box .listbox .classlist .infobox img {
    width: 110px;
    height: 70px;
    margin-right: 12px;
    flex-shrink: 0;
    object-fit: cover;
  }
  .app-container .main-content .tabs-box .listbox .classlist .infobox .info {
    height: auto;
    flex: 1;
    min-width: 0;

    .title {
      margin-bottom: 8px;
      font-size: 15px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .type {
      font-size: 13px;
    }
  }
  .app-container .main-content .tabs-box .listbox .classlist .perinfo,
  .app-container .main-content .tabs-box .listbox .classlist .money,
  .app-container .main-content .tabs-box .listbox .classlist .signup {
    width: auto;
    flex: 1;
    margin: 0;
    font-size: 13px;
    text-align: left;
  }
  .app-container .main-content .tabs-box .listbox .classlist .perinfo {
    width: 100%;
    margin-bottom: 6px;
  }
  .app-container .main-content .tabs-box .listbox .classlist .perinfo img {
    width: 32px;
    height: 32px;
  }
  .app-container .main-content .tabs-box .block {
    margin-top: 20px;
    overflow-x: auto;
  }
}

@media (max-width: 600px) {
  .app-container .main-content .bgk-img .banner-title {
    font-size: 22px;
  }
  .app-container .main-content .bgk-img .banner-subtitle {
    font-size: 13px;
  }
  .app-container .main-content .tabs-box .tabs .tab {
    min-width: 88px;
    font-size: 14px;
    padding: 0 10px;
  }
  .app-container .main-content .tabs-box .listbox {
    padding: 12px 8px;
  }
  .app-container .main-content .tabs-box .listbox .classlist {
    padding: 10px;
  }
  .app-container .main-content .tabs-box .listbox .classlist .infobox img {
    width: 96px;
    height: 62px;
    margin-right: 10px;
  }
}
</style>